import { TablePagination } from "@mui/material";
import { CAMPAIGN_TABLE_PAGE_SIZE } from "../lib/constants";

export function paginateIds(ids, page, pageSize = CAMPAIGN_TABLE_PAGE_SIZE) {
  const start = page * pageSize;
  return ids.slice(start, start + pageSize);
}

export function getCampaignTablePageCount(count, pageSize = CAMPAIGN_TABLE_PAGE_SIZE) {
  return Math.max(1, Math.ceil(count / pageSize));
}

export default function BidTablePagination({
  count,
  page,
  onPageChange,
  rowsPerPage = CAMPAIGN_TABLE_PAGE_SIZE,
}) {
  if (count <= rowsPerPage) return null;

  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      onPageChange={(_, nextPage) => onPageChange(nextPage)}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={[rowsPerPage]}
      labelDisplayedRows={({ from, to, count: total }) =>
        `${from}–${to} of ${total !== -1 ? total : `more than ${to}`}`
      }
    />
  );
}
